import { System } from '../../data/types/system/system';

export const byNameIndex = (nameIndex: number) => (system: System) =>
  system.nameIndex === nameIndex;
